import { render, staticRenderFns } from "./IndustryCaseQuery.vue?vue&type=template&id=ded8eb6c&scoped=true&"
import script from "./IndustryCaseQuery.vue?vue&type=script&lang=js&"
export * from "./IndustryCaseQuery.vue?vue&type=script&lang=js&"
import style0 from "./IndustryCaseQuery.vue?vue&type=style&index=0&id=ded8eb6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded8eb6c",
  null
  
)

export default component.exports